import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ShieldCheckSvg = function ShieldCheckSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.123 15.514 6.327-7.507-1.143-.867-5.381 6.384-2.84-2.31-.952 1.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 2.249H2v15.004l10 4.996 10-4.996zM3.463 16.415V3.638h17.074v12.777L12 20.679z",
    clipRule: "evenodd"
  }));
};
export var ShieldCheck = function ShieldCheck(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ShieldCheckSvg
  }));
};